import { ChevronRight } from '@src/Assets/svg/ChevronRight';
import React from 'react';

interface NavigationLinkProps {
  text: string;
  onClick: () => void;
  className?: string;
}

export const NavigationLink: React.FC<NavigationLinkProps> = ({ 
  text, 
  onClick, 
  className = 'common-questions-header' 
}) => {
  return (
    <div className={className} onClick={onClick}>
      <span className={`${className === 'common-questions-header' ? 'common-questions-text' : 'all-categories-link-text'}`}>{text} <ChevronRight /></span>
    </div>
  );
};
